module.exports = __webpack_public_path__ + "images/noResultImage.2328409a.svg";